(function ($) {
  Drupal.behaviors.customerServiceQAPageTab1 = {
    attach: function (context, settings) {
      var formatter = $('.cs-qa-page-tab-v1');
      var tabCollections = [];

      // sort the tabs into their respective parents, if there is more than one set of tabs per page
      formatter.each(function (i) {
        var thisFormatter = $(this);
        var foundMatch = false;

        jQuery.each(tabCollections, function (i, v) {
          if (v.container === thisFormatter.parent().get(0)) {
            v.tabs = v.tabs.add(thisFormatter.get(0));
            foundMatch = true;

            return false;
          }
        });
        if (!foundMatch) {
          tabCollections.push({
            container: thisFormatter.parent().get(0),
            tabs: $(thisFormatter.get(0)) // building a new jQuery object, instead of using the current one (i.e., thisFormatter)
          });
        }
      });

      jQuery.each(tabCollections, function (i, v) {
        var $tabBodyContainer = $(v.container),
          $tabContainer = $('<ul/>', { 'class': 'cl-tab-list' });

        $tabBodyContainer.prepend($tabContainer);
        v.tabs.each(function (i) {
          var $tabBody = $(this),
            $tab = $('<li/>', { text: $tabBody.data('tab-title') });

          $tabContainer.append($tab);
          $tab.on('click', function (e) {
            $tabContainer.children().add($tabBodyContainer.children().not($tabContainer)).removeClass('active');
            $tabBody.add($tab).addClass('active');
          });
          if (i === 0) {
            $tab.addClass('first');
            $tab.trigger('click');
          }
        });
      });
    }
  };
})(jQuery);
